module.exports = __webpack_public_path__ + "static/media/brand-refresh-lock.067755b3.svg";